import { Typography, Accordion, AccordionDetails, AccordionSummary, } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ResumoPrePedido } from '../../interfaces';
import { TabelaListaItensResumoPedido } from '../TabelaListaItensResumoPedido';
import { GoChecklist } from 'react-icons/go';
import { GiCancel } from 'react-icons/gi'
import { FiEdit } from 'react-icons/fi';
import { TextOnlyTooltip } from "../../../../themes/components/TextOnlyTooltip";
import { useModals } from "../../../../contexts/Modals";
import { Button } from "../../../../themes/components/Button";

interface PedidosEnviados {
    mensagem: string
    numped: string
    resumoId: number
    status: string
}

interface PropsItem {
    pedido: PedidosEnviados
    resumosPedidos: ResumoPrePedido[] | undefined
    handleStep: (step:number) => void
}

export function ItemPedidoEnviadoERP(props: PropsItem) {
    const { setMensagem, setShowModalInfo } = useModals();
    //const { } = usePedidos();
    let resumoPedido;
    if (props.resumosPedidos !== undefined) {
        for (let index = 0; index < props.resumosPedidos.length; index++) {
            const element = props.resumosPedidos[index];
            if (element.id === props.pedido.resumoId)
                resumoPedido = element;
        }
    }

    function confirmaEdicao() {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{`Deseja editar os itens não enviados nos pedidos?`}</Typography>
                <Typography>{`Não será possível retornar para verificar os pedidos já enviados!`}</Typography>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Button onClick={() => setShowModalInfo(false) } classBtn={"btn-notifications color-red"}>Cancelar</Button>
                    <Button onClick={() => [setShowModalInfo(false), props.handleStep(1)]} classBtn={"btn-notifications color-default"}>Sim</Button>
                </div>
            </div>);
        setShowModalInfo(true);
    }

    return (
        <div className={props.pedido.status !== "OK" ? "retorno-pedido-erp estilo-falha" : "retorno-pedido-erp estilo-sucesso"}>
            {resumoPedido !== undefined &&
                <div className="resumo-detalhe-pedidos-enviados">
                    <div className="area-title-item-pedido-erp">
                        <div style={{ width: '25px' }}></div>
                        <Typography className="resumo-detalhe-pedidos-enviados-form-title border-bottom-tittle-resume-erp">Informações do Pedido {props.pedido.numped}</Typography>
                        {props.pedido.status !== "OK" ?
                            <TextOnlyTooltip title="Editar Itens" placement="top">
                                <button onClick={() => confirmaEdicao()} style={{ border: 'none', backgroundColor: 'white' }}>
                                    <FiEdit size={22} style={{ backgroundColor: 'white', color: '#222' }} />
                                </button>
                            </TextOnlyTooltip>
                            :
                            <div style={{ width: '25px' }}></div>
                        }
                    </div>
                    <div className="area-blocos-pedidoserp">
                        <div className="bloco-info-item-pedido-erp">
                            <div className="resumo-detalhe-pedidos-enviados-form-row">
                                <div className="resumo-detalhe-pedidos-enviados-form-column">
                                    {field("Tipo do Pedido:", resumoPedido?.tipo_pedido)}
                                    {field("Empresa:", resumoPedido?.cod_empresa == 2?"GA":resumoPedido?.cod_empresa == 4?"AB":(resumoPedido?.cod_empresa).toString())}
                                    {field("Container:", resumoPedido?.numero_container)}
                                </div>
                                <div className="resumo-detalhe-pedidos-enviados-form-column">
                                    {field("Corte:", resumoPedido?.pedido_corte)}
                                    {field("Quantidade de Itens:", String(resumoPedido?.quantidade_itens))}
                                </div>
                                <div className="resumo-detalhe-pedidos-enviados-form-column">
                                    {field("Quantidade Total:", resumoPedido?.quantidade_total.toLocaleString('pt-br', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }))}
                                    {field("Valor Total:", resumoPedido?.valor_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))}
                                </div>
                            </div>
                            <div className="resumo-detalhe-pedidos-enviados-form-row">
                                <div className="resumo-detalhe-pedidos-enviados-form-column">
                                    {field("Observação:", resumoPedido?.observacao)}
                                    {field("Status:", props.pedido.mensagem)}
                                </div>
                            </div>
                        </div>
                        <div className="bloco-icon-pedido-erp">
                            {props.pedido.status === "OK" ? <GoChecklist size={85} style={{ margin: '1em auto' }} color={"#64b999"} /> : <GiCancel size={85} style={{ margin: '1em auto' }} color={"rgb(255, 117, 117)"} />}
                        </div>
                    </div>
                    <div className="resumo-detalhe-pedidos-enviados-form-row">
                        <Accordion className={props.pedido.status === "OK" ? "tabela-itens-erp-pedido table-success" : "tabela-itens-erp-pedido table-failed"}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography className={"resumo-detalhe-pedidos-enviados-form-title show-itens-resumo"}>{props.pedido.status === "OK" ? "Itens enviados" : "Itens não enviados"}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TabelaListaItensResumoPedido allowSelectitem={false} listaItens={resumoPedido?.produtosResumo ? resumoPedido.produtosResumo : []} />
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            }
        </div>
    );
}


const field = (label: string, value: string) => {
    return (
        <div className="cabecalho-detalhe-item">
            <Typography className="cabecalho-detalhe-label">{label}</Typography>
            <Typography className="cabecalho-detalhe-value">{value !== undefined ? value : ""}</Typography>
        </div>
    )
}